import { ChangePasswordModal } from 'views/pages/changePassword/modal';
import { AccountFragment } from 'views/utils/graphql/graphql';

type ForceInputModalProps = {
  account: AccountFragment;
  accountReload: () => void;  
};

export const ForceInputModal = (props: ForceInputModalProps) => {
  if (!props.account.ChangedPassword) {
    // リクエストが増えてしまうが古い情報を残したくないのでonCompletedでリロードする
    return <ChangePasswordModal onCompleted={props.accountReload} />;
  }
  
  return <></>;
};
